import React, { useCallback } from 'react';
import { Box } from '@common-fe/common-fe';

import { LARGE_SIZE_LOGO, LetterIconSizeEnum } from '@/common/constants';
import ROUTES from '@/common/routes';
import { Icon } from '@/components/elements/Icon/Icon';
import { Breadcrumbs } from '@/modules/core/components/Topbar/Breadcrumbs/Breadcrumbs';
import { useHistory } from '@/modules/core/hooks';
import { useAuthorization } from '@/modules/user/hooks';
import baseTheme from '@/styles/theme';

import { Renewal } from '../renewals.types';

import { useIsAnyStepSubmitted } from './hooks';
import RenewalSetupLeaveDropdown from './RenewalSetupLeaveDropdown';
import { PROMT_MESSAGE } from './RenewalSetupPrompt';

export interface Props {
  renewalSetupData?: Renewal;
}

const RenewalSetupTopbar: React.FC<Props> = ({
  renewalSetupData,
}) => {
  const history = useHistory();
  const { handleLogout } = useAuthorization();
  const isAnyStepSubmitted = useIsAnyStepSubmitted();

  const confirmAndLogout = useCallback(() => {
    if (isAnyStepSubmitted) {
      if (window.confirm(PROMT_MESSAGE)) {
        handleLogout();
      }
    } else {
      handleLogout();
    }
  }, [handleLogout, isAnyStepSubmitted]);

  return (
    <Box data-testid="renewal-setup-topbar" border={{ size: 'small', color: 'border1', side: 'bottom' }} style={{ position: 'relative' }}>
      <Box
        style={{
          position: 'absolute',
          left: '24px',
          top: '24px',
          cursor: 'pointer',
        }}
      >
        <RenewalSetupLeaveDropdown
          options={
            [
              {
                title: 'Go back to admin portal',
                redirectFunc: () => {
                  if (history) history.push(ROUTES.HOME);
                },
              },
              {
                title: 'Log out',
                warning: true,
                redirectFunc: confirmAndLogout,
              }
            ]
          }
        />
      </Box>
      <Box align="center" pad={{ horizontal: 'l' }}>
        <Box width={baseTheme.defaultMinContentWidth}>
          <Box
            style={{ transition: 'all 0.6s' }}
            height={{ min: '72px' }}
            width="100%"
            direction="row"
            align="center"
            justify="between"
          >
            <Box direction="row">
              <Box
                margin={{ right: 'l' }}
                data-testid="renewal-setup-topbar-logo"
              >
                <Icon
                  size={LetterIconSizeEnum.LOGO}
                  text="name"
                  height={LARGE_SIZE_LOGO.height}
                  width={LARGE_SIZE_LOGO.width}
                  src={renewalSetupData?.logo}
                />
              </Box>
              <Breadcrumbs expressSetupMode />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RenewalSetupTopbar;
